import EmailTemplates from './EmailTemplates'

const Emails = () => {
    return <EmailTemplates />
}

export default Emails
